import { ArrowRight, Calendar } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"

/**
 * CTA section for the Use Cases pages.
 * Encourages users to start building or book a demo.
 */
export function CtaSection() {
  const navigate = useNavigate()

  return (
    <section className="relative overflow-hidden bg-neutral-900 py-16 lg:py-24">
      {/* Background decoration */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute -right-40 bottom-0 h-96 w-96 rounded-full bg-secondary/10 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="mb-4 text-2xl font-bold text-white sm:text-3xl lg:text-4xl">
          Ready to Automate Your Department?
        </h2>
        <p className="mx-auto mb-8 max-w-2xl text-lg text-neutral-400">
          Deploy AI employees that work 24/7, understand your business context,
          and integrate seamlessly with your existing systems.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Button
            size="lg"
            className="group bg-primary text-white hover:bg-primary/90"
            onClick={() => navigate("/signup")}
          >
            Start Building Free
            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-neutral-700 bg-transparent text-white hover:bg-neutral-800"
            onClick={() => navigate("/demo")}
          >
            <Calendar className="mr-2 h-4 w-4" />
            Book a Demo
          </Button>
        </div>
      </div>
    </section>
  )
}
